<script>
import Layout from '@layouts/main';
import CarTypeForm from '@views/carTypes/form';

export default {
  components: {
    Layout,
    CarTypeForm,
  },
  page() {
    return {
      title: this.$t('titles.create_car_type'),
    };
  },
  data() {
    return {
      breadcrumbItems: [
        {
          text: this.$t('titles.home'),
          to: { name: 'home.index' },
        },
        {
          text: this.$t('titles.car_types'),
          to: { name: 'carTypes.index' },
        },
        {
          text: this.$t('titles.create_car_type'),
          active: true,
        },
      ],
    };
  },
  methods: {
    create() {
      this.$router.push({
        name: 'carTypes.index',
      });
    },
  },
};
</script>

<template>
  <Layout>
    <b-breadcrumb :items="breadcrumbItems" />
    <b-card
      :border-variant="!errors.items.length ? 'dark' : 'danger'"
      :header="$t('titles.create_car')"
      header-tag="header"
      :header-bg-variant="!errors.items.length ? 'dark' : 'danger'"
      header-text-variant="white"
      class="mb-3"
    >
      <CarTypeForm @submitted="create" />
    </b-card>
  </Layout>
</template>
